import { ListItem } from '../../ListItem';

export class CaseType {

    static List(): ListItem[]  {

        let list: ListItem[] =  [
          { "id": 0, "name": "NotSet" },
          { "id": 1, "name": "Case" },
          { "id": 2, "name": "Unsub" }
        ];

      return list;
    }

    static Value(name: string): number {

      let rtn: number = 0;

      CaseType.List().forEach(obj => {

        if (obj.name == name) {
          rtn = obj.id;
        }

      });

      return rtn;

    } 
    
}
